export default require("./SchoolInformation");



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolInformation/index.js